import Marquee from "react-fast-marquee";
import { GRADES, SERVICES } from "@/data";

export default function Ticker() {
  const items = [
    ...GRADES.map((g) => g.code),
    ...SERVICES,
    "MUMBAI ONLY",
    "24×7 PLANT",
  ];

  return (
    <div data-testid="ticker" className="bg-black text-[#F5F4EF] border-y border-white/15 py-5">
      <Marquee speed={45} gradient={false}>
        {items.map((t, i) => (
          <span
            key={i}
            className="marquee-item text-2xl md:text-3xl uppercase tracking-tight mx-8 flex items-center gap-8"
          >
            {t}
            <span className={i % 2 === 0 ? "text-primary" : "text-signal-yellow"}>/</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
